module.exports = __webpack_public_path__ + "img/hr-pipe-corner-up-left.3cfa5325.png";